export const VERSION ="Folcon Gen2 general purpose e-commerce"
export const BUILD_DATE ="25-09-2025"
export const PACKAGE_CODE ="A2.2025.09.25.01"
